import { render, staticRenderFns } from "./ModalReenviarDocumentoPncp.vue?vue&type=template&id=610bf436"
import script from "./ModalReenviarDocumentoPncp.vue?vue&type=script&lang=js"
export * from "./ModalReenviarDocumentoPncp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports